// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import { ShareOptions } from "@insite/client-framework/Services/WishListService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addWishListToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import translate from "@insite/client-framework/Translate";
import { CartLineCollectionModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import MyListsDetailsPageTypeLink from "@insite/content-library/Components/MyListsDetailsPageTypeLink";
import WishListSharingStatus, {
    WishListSharingStatusStyles,
} from "@insite/content-library/Components/WishListSharingStatus";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Star from "@insite/mobius/Icons/Star";
import StarX from "@insite/mobius/Icons/StarX";
import Tag from "@insite/mobius/Icons/Tag";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import OverflowMenu, { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
// import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip"; // Starter Custom Code
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { useContext } from "react";
import { connect, HandleThunkActionCreator } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StarFill from "@store/Library/Components/Toolkit/Icons/Star/StarFill";
import StarLine from "@store/Library/Components/Toolkit/Icons/Star/StarLine";
import TagLine from "@store/Library/Components/Toolkit/Icons/Tag/TagLine";
import Tooltip, { TooltipPresentationProps } from "@store/MobiusOverrides/Tooltip/Tooltip";
import { imageStyles } from "@store/Themes/common/mixins/image";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { productLineProps } from "@store/Themes/common/props/productLine";
import {
    tableGetEllipsisCellProps,
    tableProps,
    tableRemoveEllipsisCellProps,
} from "@store/Themes/common/props/table";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusUpdateStyles } from "@toolkit/Themes/common/mixins/common";

const getIconProps = (src?: IconPresentationProps["src"]) => {
    return {
        src,
        size: 20,
        color: "inherit",
    };
};

const actionClickable = () => css`
    ${x => x.theme.link.defaultProps?.css as any}
    ${linkActionStyles()}
    ${focusUpdateStyles(true)}
    padding: ${pxToRem(5, 10)};
`;
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    language: state.context.session.language,
    allowEditingOfWishLists: getSettingsCollection(state).wishListSettings.allowEditingOfWishLists,
    isUpdatingCart: state.context.isUpdatingCart,
});

interface OwnProps {
    wishList: WishListModel;
    extendedStyles?: WishListCardStyles;
    addWishListToCart: HandleThunkActionCreator<typeof addWishListToCart>;
    deleteWishList?: () => void;
    leaveWishList?: () => void;
    toggleFavorite?: () => void;
    toggleHide?: () => void;
    // Starter Custom Code
    showFavorites?: boolean;
    showTags?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export interface WishListCardStyles {
    gridContainer?: GridContainerProps;
    wishListInfoGridItem?: GridItemProps;
    wishListInfoGridContainer?: GridContainerProps;
    basicInfoGridItem?: GridItemProps;
    basicInfoGridContainer?: GridContainerProps;
    detailLinkGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    descriptionText?: TypographyProps;
    lastUpdatedGridItem?: GridItemProps;
    lastUpdatedText?: TypographyProps;
    extendedInfoGridItem?: GridItemProps;
    extendedInfoGridContainer?: GridContainerProps;
    productImagesGridItem?: GridItemProps;
    productImageLink?: LinkPresentationProps;
    productImage?: LazyImageProps;
    sharingStatusGridItem?: GridItemProps;
    sharingStatus?: WishListSharingStatusStyles;
    actionGridItem?: GridItemProps;
    actionGridMediumHidden?: HiddenProps;
    actionOverflowIcon?: IconPresentationProps;
    actionOverflowMenu?: OverflowMenuPresentationProps;
    actionAddToCartClickable?: ClickablePresentationProps;
    actionHideClickable?: ClickablePresentationProps;
    actionDeleteClickable?: ClickablePresentationProps;
    actionLeaveClickable?: ClickablePresentationProps;
    actionAddToCartButton?: ButtonPresentationProps;
    actionHideLink?: LinkPresentationProps;
    actionDeleteButton?: ButtonPresentationProps;
    actionLeaveButton?: ButtonPresentationProps;
    actionFavoriteClickable?: ClickablePresentationProps;
    basicIconGridContainer?: GridContainerProps;
    detailIconGridItem?: GridItemProps;
    starIcon?: IconPresentationProps;
    starXIcon?: IconPresentationProps;
    tagTooltip?: TooltipPresentationProps;
    // Starter Custom Code
    iconCell?: DataTableCellProps;
    listNameDescriptionCell?: DataTableCellProps;
    dateCell?: DataTableCellProps;
    statusCell?: DataTableCellProps;
    itemsCell?: DataTableCellProps;
    itemsWrapper?: InjectableCss;
    itemsImageWrapper?: InjectableCss;
    itemProductImage?: ProductImageStyles;
    actionsCell?: DataTableCellProps;
    actionsWrapper?: InjectableCss;
    actionAddToCartLink?: LinkPresentationProps;
    actionLeaveLink?: LinkPresentationProps;
    actionDeleteLink?: LinkPresentationProps;
    actionUnhideLink?: LinkPresentationProps;
}

export const wishListCardStyles: WishListCardStyles = {
    iconCell: {
        css: css`
            padding: 0;
        `,
    },
    listNameDescriptionCell: tableGetEllipsisCellProps(220),
    dateCell: tableGetEllipsisCellProps(155),
    itemsCell: tableProps.narrowCell,
    itemsWrapper: {
        css: css`
            display: flex;
            gap: ${pxToRem(5)};
        `,
    },
    itemsImageWrapper: {
        css: css`
            ${x => imageStyles(x.theme.design.product.image.small.ratio)}
            width: ${pxToRem(50)};
            flex: 0 0 auto;
        `,
    },
    itemProductImage: {
        linkWrappingImage: {
            css: css`
                ${focusUpdateStyles(true)}
                z-index: 0;
            `,
        },
        img: {
            css: css`
                z-index: -1;
            `,
        },
    },
    statusCell: tableGetEllipsisCellProps(180),
    actionsCell: tableProps.narrowCell,
    actionAddToCartLink: productLineProps.addToCartLink,
    actionLeaveLink: productLineProps.leaveLink,
    actionDeleteLink: productLineProps.removeLink,
    actionHideLink: productLineProps.hideLink,
    actionUnhideLink: productLineProps.unhideLink,
    actionFavoriteClickable: {
        css: css`
            ${actionClickable()}
        `,
    },
    starIcon: getIconProps(StarLine),
    starXIcon: getIconProps(StarFill),
    tagTooltip: {
        iconProps: getIconProps(TagLine),
        cssOverrides: {
            tooltipContainer: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipContainer}
                bottom: 80%;
                left: 5px;
                justify-content: flex-start;
                transform: none;
            `,
            tooltipArrow: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipArrow}
                left: 7%;
            `,
            tooltipWrapper: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipWrapper}
                margin-left: 0;
            `,
            tooltipClickable: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipClickable}
                ${actionClickable()}
            `,
        },
    },
};

const WishListCard = ({
    language,
    allowEditingOfWishLists,
    isUpdatingCart,
    extendedStyles,
    wishList,
    addWishListToCart,
    deleteWishList,
    leaveWishList,
    toggleFavorite,
    toggleHide,
    // Starter Custom Code
    showFavorites,
    showTags,
}: Props) => {
    const toasterContext = useContext(ToasterContext);
    const isLoadingAnyList = useAppSelector(state => Object.keys(state.data.wishLists.isLoading).length > 0);

    /* Starter Custom Code - Start */
    const trackAddWishListToCart = ga.use.trackAddWishListToCart({}, { wishList });
    const trackAddToCart = ga.use.trackAddToCart({}, { wishList });
    /* Starter Custom Code - End */

    const clickAddToCartHandler = (e: any) => {
        e.preventDefault();
        addWishListToCart({
            apiParameter: { wishListId: wishList.id },
            onSuccess: onAddAllToCartSuccess,
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps.apiResult);
                } else if (resultProps.errorMessage) {
                    toasterContext.addToast({
                        body: resultProps.errorMessage,
                        messageType: "danger",
                    });
                }
            },
        });
    };

    const onAddAllToCartSuccess = (result: CartLineCollectionModel) => {
        /* Starter Custom Code - Start */
        trackAddWishListToCart();
        trackAddToCart();
        /* Starter Custom Code - End */
        toasterContext.addToast({
            body: result.notAllAddedToCart
                ? siteMessage("Lists_Items_Not_All_Added_To_Cart")
                : translate("List Added to Cart"),
            messageType: "success",
        });
    };

    const updatedOnDisplay = getLocalizedDateTime({
        dateTime: new Date(wishList.updatedOn),
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });
    /* Starter Custom Code - Start */
    const lastUpdatedDisplay =
        wishList.updatedByDisplayName && !wishList.isAutogenerated
            ? ` ${translate("by")} ${wishList.updatedByDisplayName}`
            : null;
    /* Starter Custom Code - End */

    const styles = useMergeProps(wishListCardStyles, extendedStyles); // Starter Custom Code
    const canAddToCart = wishList.canAddToCart && !!wishList.wishListLinesCount && wishList.wishListLinesCount > 0;
    const addToCartLabel = translate("Add List to Cart");
    const toggleHideButtonText = wishList.isHidden ? translate("Unhide List") : translate("Hide List");
    const toggleHideButtonStyles = wishList.isHidden ? styles.actionUnhideLink : styles.actionHideLink; // Starter Custom Code
    const deleteLabel = translate("Delete");
    const leaveLabel = translate("Leave List");

    /* Starter Custom Code - Start */
    const statusCellStyles = React.useMemo(() => {
        if (wishList?.isSharedList || wishList?.wishListSharesCount) {
            return styles.statusCell;
        }

        return mergeProps<typeof styles.statusCell>(styles.statusCell, tableRemoveEllipsisCellProps());
    }, [styles.statusCell, wishList?.isSharedList, wishList?.wishListSharesCount]);

    const tagsText = translate("View Tags Assigned");
    /* Starter Custom Code - End */

    return (
        <>
            {/* Starter Custom Code - Start */}
            <DataTableRow data-test-selector="wishListCard">
                {(showFavorites || showTags) && (
                    <DataTableCell {...styles.iconCell}>
                        {showFavorites && (
                            <Clickable
                                {...styles.actionFavoriteClickable}
                                onClick={toggleFavorite}
                                data-test-selector={`myListsFavorite_${wishList.id}`}
                                disabled={isLoadingAnyList || wishList.isAutogenerated}
                            >
                                {wishList.isFavorite && (
                                    <Icon
                                        {...styles.starXIcon}
                                        data-test-selector={`myListsFavoriteStarXIcon_${wishList.id}`}
                                        title={translate("Remove from my favorites")}
                                    />
                                )}
                                {!wishList.isFavorite && (
                                    <Icon
                                        {...styles.starIcon}
                                        data-test-selector={`myListsFavoriteStarIcon_${wishList.id}`}
                                        title={translate("Add to my favorites")}
                                    />
                                )}
                            </Clickable>
                        )}
                        {showTags && (
                            <Tooltip
                                {...styles.tagTooltip}
                                text={
                                    wishList.wishListTags?.length
                                        ? `${translate("{0}:", translate("Tags Assigned"))} ${wishList.wishListTags
                                              .map(o => o.tag)
                                              .join(", ")}`
                                        : translate("No Tags Assigned")
                                }
                                triggerAltText={tagsText}
                                clickableTitle={tagsText}
                            />
                        )}
                    </DataTableCell>
                )}
                <DataTableCell {...styles.listNameDescriptionCell}>
                    <MyListsDetailsPageTypeLink
                        title={wishList.name}
                        wishListId={wishList.id}
                        testSelector="wishListCardName"
                    />
                    {wishList.description && (
                        <Typography {...styles.descriptionText} data-test-selector="wishListCardDescription">
                            {wishList.description}
                        </Typography>
                    )}
                </DataTableCell>
                <DataTableCell {...styles.dateCell}>
                    <Typography {...styles.lastUpdatedText} data-test-selector="wishListCardLastUpdated">
                        {updatedOnDisplay}
                    </Typography>
                    {lastUpdatedDisplay ? (
                        <Typography {...styles.lastUpdatedText} data-test-selector="wishListCardLastUpdated">
                            {lastUpdatedDisplay}
                        </Typography>
                    ) : null}
                </DataTableCell>
                <DataTableCell {...styles.itemsCell}>
                    <StyledWrapper {...styles.itemsWrapper}>
                        {wishList.wishListLineCollection &&
                            wishList.wishListLineCollection.length > 0 &&
                            wishList.wishListLineCollection.slice(0, 3).map(line => (
                                <StyledWrapper {...styles.itemsImageWrapper} key={line.id.toString()}>
                                    <ProductImage product={line as any} extendedStyles={styles.itemProductImage} />
                                </StyledWrapper>
                            ))}
                    </StyledWrapper>
                </DataTableCell>
                <DataTableCell {...statusCellStyles}>
                    <WishListSharingStatus extendedStyles={styles.sharingStatus} wishList={wishList} />
                </DataTableCell>
                <DataTableCell {...styles.actionsCell}>
                    <StyledWrapper {...styles.actionsWrapper}>
                        <Link
                            {...styles.actionAddToCartLink}
                            disabled={!canAddToCart || isUpdatingCart}
                            onClick={clickAddToCartHandler}
                        >
                            {addToCartLabel}
                        </Link>
                        {allowEditingOfWishLists &&
                        !!leaveWishList &&
                        wishList.isSharedList &&
                        wishList.shareOption !== ShareOptions.AllCustomerUsers ? (
                            <Link {...styles.actionLeaveLink} onClick={leaveWishList}>
                                {leaveLabel}
                            </Link>
                        ) : (
                            <Link
                                {...styles.actionDeleteLink}
                                disabled={
                                    !deleteWishList ||
                                    wishList.isSharedList ||
                                    !allowEditingOfWishLists ||
                                    wishList.isAutogenerated
                                }
                                onClick={deleteWishList}
                                data-test-selector={`wishListCardDeleteButton_${wishList.id}`}
                            >
                                {deleteLabel}
                            </Link>
                        )}
                        {!wishList.isAutogenerated && (
                            <Link {...toggleHideButtonStyles} disabled={isLoadingAnyList} onClick={toggleHide}>
                                {toggleHideButtonText}
                            </Link>
                        )}
                    </StyledWrapper>
                </DataTableCell>
            </DataTableRow>
            {/* Starter Custom Code - End */}
        </>
    );
};

export default connect(mapStateToProps)(WishListCard);
